export default __webpack_public_path__ + "static/media/circle_4.6cd2d8c0.png";